const obj = {
  compare: {
    shallow(obj1: Record<string, any>, obj2: Record<string, any>) {
      return (
        Object.keys(obj1).length === Object.keys(obj2).length &&
        Object.keys(obj1).every((key) => obj1[key] === obj2[key])
      );
    },
  },
  // See: https://stackoverflow.com/questions/52856496/typescript-object-keys-return-string
  keys: Object.keys as <T>(
    obj: T,
  ) => (keyof T extends infer U
    ? U extends string
      ? U
      : U extends number
        ? `${U}`
        : never
    : never)[],
  filter: <T extends Record<string, any>>(o: T) =>
    Object.fromEntries(Object.entries(o).filter(([_, v]) => !!v)) as T,
  isEmpty(obj: Record<string, any>) {
    return Object.keys(obj).length === 0;
  },
};

export default obj;
